export const CAUSES_PERMISSION_CODES = {
  VIEW_SECTION: 'CAUSAS.VER_SECCION_40',
  CREATE: 'CAUSAS.CREAR_CAUSA',
  DOWNLOAD_EXCEL: 'CAUSAS.DESCARGAR_EXCEL',
  VIEW_DETAIL: 'CAUSAS.VER_DETALLE',
  VIEW_BLOCKED_CLIENT_CAUSE: 'CAUSAS.VER_CAUSA_DE_CLIENTE_EN_BAJA_BLOQUEADO',
  DETAIL: 'CAUSAS.DETALLE_CAUSA',
  DETAIL_VIEW_SECTION: 'CAUSAS.VER_SECCION_45',
  EDIT: 'CAUSAS.EDITAR_CAUSA',
  VIEW_CLIENT: 'CAUSAS.VER_CLIENTE',
  ADD_USER: 'CAUSAS.AGREGAR_USUARIO',
  REMOVE_USER: 'CAUSAS.QUITAR_USUARIO',
  LEGACY_MOVEMENTS: 'CAUSAS.MOVIMIENTOS_LEGACY',
  MOVEMENTS: 'CAUSAS.MOVIMIENTOS',
  MOVEMENTS_VIEW_SECTION: 'CAUSAS.VER_SECCION_52',
  VIEW_DOCUMENT: 'CAUSAS.VER_DOCUMENTO',
  MANAGE_MOVEMENTS: 'CAUSAS.GESTIONAR_MOVIMIENTOS',
  TASKS: 'CAUSAS.TAREAS',
  TASKS_VIEW_SECTION: 'CAUSAS.VER_SECCION_56',
  CREATE_TASK: 'CAUSAS.CREAR_TAREA',
  MANAGE_TASK: 'CAUSAS.GESTINAR_TAREA',
  EDIT_TASK: 'CAUSAS.EDITAR_TAREA',
  PUBLISH_COMMENT: 'CAUSAS.PUBLICAR_COMENTARIO',
  ATTACH_FILE: 'CAUSAS.ADJUNTAR_ARCHIVO_A_COMENTARIO',
};
